import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Optimizes an image URL from the Auxo asset CDN using Cloudflare on-the-fly resizing.
 * @param {string} url - The original asset URL.
 * @param {object} options - Resizing options (width, height, quality, fit).
 * @returns {string} The optimized image URL.
 */
export function getOptimizedImageUrl(url, { width, height, quality = 80, fit = "cover" } = {}) {
  if (!url || !url.startsWith("https://assets.auxodev.dk")) return url;
  
  // If the URL already contains /cdn-cgi/image/, don't double wrap it
  if (url.includes("/cdn-cgi/image/")) return url;

  const optionsArray = [`quality=${quality}`, "format=auto"];
  if (width) optionsArray.push(`width=${width}`);
  if (height) {
    optionsArray.push(`height=${height}`);
    optionsArray.push(`fit=${fit}`);
  }

  const optionsString = optionsArray.join(",");
  return url.replace("https://assets.auxodev.dk/", `https://assets.auxodev.dk/cdn-cgi/image/${optionsString}/`);
}

